var _mask, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#47A7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#9098A3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.995 9C9.235 9 7 11.24 7 14C7 16.76 9.235 19 11.995 19C14.76 19 17 16.76 17 14C17 11.24 14.76 9 11.995 9ZM15.46 12H13.985C13.825 11.375 13.595 10.775 13.295 10.22C14.215 10.535 14.98 11.175 15.46 12ZM12 10.02C12.415 10.62 12.74 11.285 12.955 12H11.045C11.26 11.285 11.585 10.62 12 10.02ZM8.13 15C8.05 14.68 8 14.345 8 14C8 13.655 8.05 13.32 8.13 13H9.82C9.78 13.33 9.75 13.66 9.75 14C9.75 14.34 9.78 14.67 9.82 15H8.13ZM8.54 16H10.015C10.175 16.625 10.405 17.225 10.705 17.78C9.785 17.465 9.02 16.83 8.54 16ZM10.015 12H8.54C9.02 11.17 9.785 10.535 10.705 10.22C10.405 10.775 10.175 11.375 10.015 12ZM12 17.98C11.585 17.38 11.26 16.715 11.045 16H12.955C12.74 16.715 12.415 17.38 12 17.98ZM13.17 15H10.83C10.785 14.67 10.75 14.34 10.75 14C10.75 13.66 10.785 13.325 10.83 13H13.17C13.215 13.325 13.25 13.66 13.25 14C13.25 14.34 13.215 14.67 13.17 15ZM13.295 17.78C13.595 17.225 13.825 16.625 13.985 16H15.46C14.98 16.825 14.215 17.465 13.295 17.78ZM14.18 15C14.22 14.67 14.25 14.34 14.25 14C14.25 13.66 14.22 13.33 14.18 13H15.87C15.95 13.32 16 13.655 16 14C16 14.345 15.95 14.68 15.87 15H14.18Z",
    fill: "#9098A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V0L21 6H17C15.8954 6 15 5.10457 15 4Z",
    fill: "#9098A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/Website.a4f841f60f6c8dc6b490aaf9e271cdf1.svg";
export { ForwardRef as ReactComponent };